export default {
  setRouteName(state, data) {
    state.routeName = data;
  },
  authUser(state, data) {
    state.token = data.token;
  },

  setLoginCheck(state, data) {
    state.loginCheck = data;
  },

  setLoginCode(state, data) {
    state.loginCode = data.data;
  },
  setLoginBranch(state, data) {
    state.loginBranch = data.data;
  },
  setCheckCode(state, data) {
    state.checkCode = data;
  },

  setCurrentUser(state, data) {
    state.currentUser = data;
  },

  clearAuth(state) {
    state.token = null;
  },

  // Alert Handles ---------------------------------------

  setPostCheck(state, data) {
    state.postCheck = data;
  },

  setInfo(state, data) {
    state.checkAlert = 4;
    state.infoMessage = data;
  },

  setWarning(state, data) {
    state.checkAlert = 3;
    state.warningMessage = data;
  },

  setError(state, data) {
    state.checkAlert = 2;
    state.dangerMessage = data;
  },

  setSuccess(state, data) {
    state.checkAlert = 1;
    state.successMessage = data;
  },

  expireAlert(state) {
    state.checkAlert = 0;
    state.successMessage = null;
    state.dangerMessage = null;
    state.warningMessage = null;
    state.infoMessage = null;
  },

  setLoading(state, data) {
    state.loadingCheck = data.status;
    state.loadingMessage = data.message;
  },

  setLoadingBtn(state, data) {
    state.loadingBtn = data;
  },
};
